import { useNavigate } from 'react-router-dom';
import ComplaintsCard from './ComplaintsCard';
import React from 'react';

const ComplaintsRaising = ({ complaintRaise, usersWithUnassignedComplaints }: any) => {
  const navigate = useNavigate();
  const navigatetocomplaints = () => {
    // console.log('id',id);
    navigate('/complaints');
  };
  return (
    // <div className="flex flex-col gap-y-4 bg-[#343434] rounded-lg p-4 pr-2">
    <div className="flex flex-col bg-[#343434] rounded-lg p-4 pr-2">
      <label className="text-xs md:text-base font-normal text-white">Complaints Raising</label>

      {complaintRaise?.length === 0 ? (
        <div className="h-[298px] text-center content-center">
          <label className="text-gray-300 text-sm">No Complaint Raised</label>
        </div>
      ) : (
        <div className="flex flex-col gap-y-1.5 h-[300px] overflow-y-auto pr-2">
          <ComplaintsCard
            info={complaintRaise}
            navigatetocomplaints={navigatetocomplaints}
            usersWithUnassignedComplaints={usersWithUnassignedComplaints}
          />
        </div>
      )}
    </div>
  );
};

export default ComplaintsRaising;
